var _g, _path, _g2, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontMiddleOffsetMiddle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 162,
    viewBox: "0 0 124 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3482_6194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 38.8008L70 10.8008V68.8008L15 96.8008L15 38.8008Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15 38.8008L70 10.8008V68.8008L15 96.8008L15 38.8008Z",
    fill: "#EC691A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3482_6194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7 70L89.7 42V100L34.7 128L34.7 70Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M34.7 70L89.7 42V100L34.7 128L34.7 70Z",
    fill: "#EC691A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 34C62.5 33.7239 62.2761 33.5 62 33.5C61.7239 33.5 61.5 33.7239 61.5 34H62.5ZM61.6464 44.3536C61.8417 44.5488 62.1583 44.5488 62.3536 44.3536L65.5355 41.1716C65.7308 40.9763 65.7308 40.6597 65.5355 40.4645C65.3403 40.2692 65.0237 40.2692 64.8284 40.4645L62 43.2929L59.1716 40.4645C58.9763 40.2692 58.6597 40.2692 58.4645 40.4645C58.2692 40.6597 58.2692 40.9763 58.4645 41.1716L61.6464 44.3536ZM61.5 34V44H62.5V34H61.5Z",
    fill: "#EC691A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3482_6194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 83.5L109 55.5V113.5L54 141.5L54 83.5Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54 83.5L109 55.5V113.5L54 141.5L54 83.5Z",
    fill: "#A0A0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8885 105.385L15 115.897L34.8885 137.618L53.9766 140.098M87 124L83.9 144L56.3242 140.414",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.96 140.102L56.336 140.417",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6999 144L83.7999 126.5M14.9999 115.897V38.8512M89.5 33L83.8758 67.8019L34.8883 61.5M89.5 33L69.9695 11M89.5 33L109 55M34.8883 61.5L14.9999 38.8512M34.8883 61.5L54 83.5M69.9695 11L14.9999 38.8512M69.9695 11L69.9999 51.957",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70 51.9319V88",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.8 67.9004V126.7",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.0835 123.862L89.5 106.954L69.9695 88L34.7291 105.486",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9543 137.412L34.9543 61.8661L89.5015 33.0144L89.5015 65.3843",
    stroke: "#EC691A",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.5 106.935L89.5 65.373",
    stroke: "#EC691A",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3482_6194",
    x: 0,
    y: 0.800781,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3482_6194",
    x: 19.7,
    y: 32,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6194",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3482_6194",
    x: 39,
    y: 45.5,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6194",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontMiddleOffsetMiddle);
export default __webpack_public_path__ + "static/media/FrontMiddleOffsetMiddle.5c42c785bf6a3d3fd0788936d2b74efd.svg";
export { ForwardRef as ReactComponent };